import { render, staticRenderFns } from "./NotasList.vue?vue&type=template&id=30a3875b"
import script from "./NotasList.vue?vue&type=script&lang=js"
export * from "./NotasList.vue?vue&type=script&lang=js"
import style0 from "./NotasList.vue?vue&type=style&index=0&id=30a3875b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports